// extracted by mini-css-extract-plugin
module.exports = {"productReviewSummary":"ProductReviewsSideDrawer_productReviewSummary__a_XNL"};